























import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class ChoosePlanTab extends Vue {
    @Prop() title!: string
    @Prop() tabItems!: string[]
    @Prop({ default: { color: '#087426', background: '#E2FFDD' } }) selectedTabColor!: {
        background: string
        color: string
    }
    @Prop() tabValue!: string
    tabValueLocal: string = ''

    @Emit('returnTabValue')
    watchTab() {
        return this.tabValueLocal
    }
    selectedTabStyle(tab: string, index: string): any {
        if (tab === index) {
            return {
                color: this.selectedTabColor.color,
                'background-color': this.selectedTabColor.background,
                'border-radius': '20px',
                // width: '99%',
                margin: 0,
                padding: 0,
            }
        } else {
            return {
                // width: '99%',
                margin: 0,
                padding: 0,
            }
        }
    }
    created(): void {
        this.tabValueLocal = this.tabValue
    }
}
